// src/NewPage.js
import React, {useEffect, useState} from 'react';
import { Helmet } from 'react-helmet';
import {HomeHeader} from "../../components/header/header";
import Footer from "../../components/footer/footer";

const Index = () => {
    const [rootCategories, setRootCategories] = useState([]);


    useEffect(() => {
        const fetchData = () => {
            fetch("/api/category/root").then(response=>response.json()).then(data=>{
                setRootCategories(data.data)
            })
        };

        fetchData();
    }, []);



    let mainContent = (

        <div className="col-12 container-fluid" id="main-content-column">
            <div className="EL-homepage row">
                <div className="col-12 justify-content-md-center logo-centering d-flex align-items-center">
                    <div tabIndex={0} className="col-md-4 d-none d-lg-block mx-2 px-3 px-md-4" id="fred-homepage-desc">
                        <h1 className="trust-h1" style={{textAlign: 'left', fontFamily: 'SimHei,serif'}}>
                            {/*欢迎来到数据免，我们是一家小型商用数据服务公司，我们希望能够以最便捷、快速、低成本的访问方式，为企业及个人提供数据要素*/}
                        </h1>
                    </div>
                    <div tabIndex={0} className="col-md-4 col-12 center-content pb-4 pb-md-0" id="fred-homepage-logo">
                        <img className="homepage-logo" src="/static/images/fred-logo-2x.png" alt="Data Rabbit Data" aria-label="Data Rabbit logo- Economic Data" />
                    </div>
                    <div tabIndex={0} className="col-md-4 d-none d-lg-block center-content-vertically mx-2 px-3" id="fred-homepage-trust" style={{fontFamily: 'SimHei,serif'}}>
              <span>
                {/*在这里，你不仅可以快速的检索所需要的数据信息，并且可以以可视化的方式快速的观察数据背后所反映的现象及趋势*/}
              </span>
                    </div>
                    <div className="col-sm-12 d-none d-md-block d-lg-none" id="fred-homepage-desc-trust">
                        {/* 欢迎来到数据免，我们是一家小型商用数据服务公司，我们希望能够以最便捷、快速、低成本的访问方式，为企业及个人提供数据要素
        <span>
          在这里，你不仅可以快速的检索所需要的数据信息，并且可以以可视化的方式快速的观察数据背后所反映的现象及趋势
      </span>*/}
                    </div>
                    <div className="row col-12 d-md-none px-4">
                        <div className="col-4 d-md-none mobile-search-toggle">
                            <button id="search-button-toggle" className="button-search-toggle col-3 d-md-none">  <i className="fa fa-search homepage-search-icon" /></button>
                        </div>
                        <div className="col-8 d-md-none fred-desc-mobile">
                <span>
                  {/*欢迎来到数据免，我们是一家小型商用数据服务公司，我们希望能够以最便捷、快速、低成本的访问方式，为企业及个人提供数据要素
          <span>
          在这里，你不仅可以快速的检索所需要的数据信息，并且可以以可视化的方式快速的观察数据背后所反映的现象及趋势*/}
                </span>
                        </div>
                    </div>
                </div>
                <div className="col-12 d-none d-md-block gx-0" id="home-search-visibility">
                    <form className="row col-10 col-lg-8 mx-auto EL-homepage-search" id="home-search" cstyle="margin-top:1em;margin-bottom:1em;" action="/searchresults">
                        <div className="input-group" id="homepage-search-container">
                            <div className="search-input-homepage-container">
                                <input name="st" type="text" className="search-input-homepage" aria-label="Search DATA RABBIT Data" placeholder="试着在这里搜索一些你感兴趣的主题……" />
                            </div>
                            <button tabIndex={0} className="btn homepage-search-button" type="submit" aria-label="search Rabbit">
                                <i className="fa fa-search homepage-search-icon" />
                            </button>
                        </div>
                    </form>
                </div>
                <div className="col-12 explore-cards center-content">
                    <div id="scroll-cards" className="row col-md-12 col-lg-8 col-12 flex-nowrap">
                        <div className="col-1 d-lg-none mt-4 mt-md-3">
                            <div className="explore-text pt-xs-2 pt-sm-4 pt-md-5">
                                EXPLORE
                            </div>
                        </div>
                        <div className="col-7 col-md-5 col-lg-6 ps-lg-4 pe-lg-3 ps-xl-5" style={{height: '100%'}}>
                            <div className="explore-card">
                                <h2 className="explore-card-title">试着搜索一些你感兴趣的主题:</h2>
                                <div className="explore-card-content divider-border">
                                    <a className="trending-search-item trending-search-gtm" href="/searchresults/?st=人口&isTst=1" aria-label="人口">人口</a>
                                    <a className="trending-search-item trending-search-gtm" href="/searchresults/?st=经济&isTst=1" aria-label="经济">经济</a>
                                    <a className="trending-search-item trending-search-gtm" href="/searchresults/?st=能源&isTst=1" aria-label="能源">能源</a>
                                    <a className="trending-search-item trending-search-gtm" href="/searchresults/?st=贸易&isTst=1" aria-label="贸易">贸易</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-7 col-md-5 col-lg-6" style={{height: '100%'}}>
                            <div className="explore-card">
                                <h2 className="explore-card-title">按照数据类别浏览:</h2>
                                <div className="explore-card-content">
                                    {
                                        rootCategories.map((item,index) => (
                                            <a className="browse-data-item home-browse-categories-gtm"
                                               href={'/categories/'+item.id} >{item.name}</a>
                                        ))
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="homepage-spacer col-12" />
                <button disabled id="filter-button" className="drawer-dropdown-trigger filter-tags-btn btn affix btn-block btn-default dropdown-is-active"><i className="fa fa-filter" style={{paddingRight: 5}} />Filter <span className="badge badge-primary hidden">0</span></button>
            </div>
            <style dangerouslySetInnerHTML={{__html: "\n    a{\n        text-decoration: none;\n    }\n    .h2-508 {\n        font-size: 1em !important;\n        margin-top: 2px !important;\n        margin-bottom: 2px !important\n    }\n" }} />
            <br className="clear" />
        </div>
    );

    return (
        <div id='container' className='container'>
            <link rel="stylesheet" href="/static/css/1717421276.home.min.css"/>
            <Helmet>
                <title>数据兔</title>
            </Helmet>
            <HomeHeader/>
            <div className='row clear' id='content-container'>
                {mainContent}
                <Footer/>
            </div>
        </div>
    );
};

export default Index;
